module.exports = __webpack_public_path__ + "static/media/menu_relatorio_exame.d871081b.png";